import { useMemo } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'
import { FinanceFinancialDocumentComplianceExtraFieldsConfig } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import {
  SaleInvoiceDocument,
  SalesInvoiceProject,
  buildAddress,
  buildComplianceItems,
  buildDetailsLeft,
  buildDetailsRight,
} from 'modules/finance/lib/salesInvoiceUtils'

interface SummaryProps {
  saleInvoice: SaleInvoiceDocument
  complianceExtraFieldsConfigsByCountry?: FinanceFinancialDocumentComplianceExtraFieldsConfig
  relatedProject?: SalesInvoiceProject
  showInvoiceNumber?: boolean
}

const Summary = ({
  saleInvoice,
  complianceExtraFieldsConfigsByCountry,
  relatedProject,
  showInvoiceNumber = false,
}: SummaryProps) => {
  const { navigation } = useNavigation()

  const address = useMemo(() => buildAddress(saleInvoice), [saleInvoice])

  const { complianceItemsLeft, complianceItemsRight } = useMemo(
    () => buildComplianceItems(saleInvoice, complianceExtraFieldsConfigsByCountry),
    [saleInvoice, complianceExtraFieldsConfigsByCountry]
  )

  const detailsLeft = useMemo(
    () => buildDetailsLeft(saleInvoice, address, complianceItemsLeft, navigation),
    [saleInvoice, address, complianceItemsLeft, navigation]
  )

  const detailsRight = useMemo(
    () =>
      buildDetailsRight(
        saleInvoice,
        complianceItemsRight,
        navigation,
        showInvoiceNumber,
        relatedProject
      ),
    [saleInvoice, complianceItemsRight, showInvoiceNumber, navigation]
  )

  return (
    <Box flexDirection="row">
      <Box width="full">
        <DetailsItemsList title={''} details={detailsLeft} />
      </Box>
      <Box width="full">
        <DetailsItemsList title={''} details={detailsRight} />
      </Box>
    </Box>
  )
}

export default Summary
